<div class="locked-staking-unstake-disclaimer wrapper">
	<div class="content">
		<div class="title">{{ "locked_staking_eth_unstake_disclaimer_title" | translate }}</div>
		<div class="description">{{ "locked_staking_eth_unstake_disclaimer_description" | translate }}</div>
	</div>

	<div class="buttons">
		<bp-button (click)="onButtonClick.emit()" fluid size="large" variant="primary">{{
			"i_understood" | translate
		}}</bp-button>
		<bp-button (click)="openLink()" fluid size="large" variant="secondary">{{ "learn_why" | translate }}</bp-button>
	</div>
</div>
